(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("9qhnb", function(module, exports) {
const $6dc404a79fc81cfa$var$headerLineClamp = document.querySelectorAll(".--js-header-line-clamp");
$6dc404a79fc81cfa$var$headerLineClamp.forEach((item)=>{
    const heading = item.querySelector(".--js-header-line-clamp-heading");
    const perex = item.querySelector(".--js-header-line-clamp-perex");
    const max = parseInt(item.dataset.headerLineClampMax ?? "4");
    if (!perex || !heading) return;
    const calculateLineClamp = (max)=>{
        const elementHeight = heading.clientHeight;
        const lineHeight = parseFloat(window.getComputedStyle(heading).lineHeight);
        const lines = Math.round(elementHeight / lineHeight);
        for(let i = 0; i < max; i++)perex?.classList.remove(`u-clamp-${i}`);
        perex?.classList.add(`u-clamp-${max - lines}`);
    };
    calculateLineClamp(max);
    window.addEventListener("resize", ()=>calculateLineClamp(max));
});

});

})();
//# sourceMappingURL=header-line-clamp.45332de6.js.map
